/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PackageResponse = zod
	.object({
		generation: zod.number().describe('Package generation number'),
		key: zod.string().describe('Package key identifier'),
		name: zod.string().describe('Package display name')
	})
	.describe('A billing package');

export type PackageResponse = zod.input<typeof PackageResponse>;
export type PackageResponseOutput = zod.output<typeof PackageResponse>;
